import { render } from "./RDFCorrelation.vue?vue&type=template&id=580c4639&scoped=true"
import script from "./RDFCorrelation.vue?vue&type=script&lang=js"
export * from "./RDFCorrelation.vue?vue&type=script&lang=js"

import "./RDFCorrelation.vue?vue&type=style&index=0&id=580c4639&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580c4639"]])

export default __exports__